import { render } from "./terms-modal.vue?vue&type=template&id=3ceff31f&scoped=true"
import script from "./terms-modal.vue?vue&type=script&lang=js"
export * from "./terms-modal.vue?vue&type=script&lang=js"

import "./terms-modal.vue?vue&type=style&index=0&id=3ceff31f&lang=sass&scoped=true"

import exportComponent from "/Users/ohirjak/projects/mov-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ceff31f"]])

export default __exports__